module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Sort3-ee3f43d03f3cdebb14bf8e73bd3afcbd.svg";